import classnames from "classnames";
import React from "react";
import { Link } from "react-router";
import _ from "underscore";
import { LazyLoadImage, LinkButton } from "../../../core/atoms/atoms";

import "./ctaBlock.scss";

interface Props {
  backgroundImage?: IResponsiveImage;
  alt?: string;
  linkUrl?: string;
  linkText?: string;
  bodyTitle?: string;
  bodyText?: string[];
  boxAlignX?: "left" | "right";
  boxAlignY?: "top" | "bottom";
}

export class CallToActionBlock extends React.Component<Props> {
  public static defaultProps: Partial<Props> = {
    boxAlignX: "right",
    boxAlignY: "bottom",
  };

  private convertBodyText(): JSX.Element[] {
    const { bodyText } = this.props;
    const arrayStrings: boolean = _.isArray(bodyText);

    if (arrayStrings) {
      if (bodyText.length > 0) {
        return bodyText.map((str, index) => <p key={index} className="cta-block-text text--regular">{str}</p>);
      }
    }
  }

  private displayContent() {
    const { boxAlignX, boxAlignY, linkText, linkUrl, bodyTitle } = this.props;
    const bodyClass = classnames("cta-block-body", {
      "cta-block-body-left": boxAlignX === "left",
      "cta-block-body-right": boxAlignX === "right",
      "cta-block-body-top": boxAlignY === "top",
      "cta-block-body-bottom": boxAlignY === "bottom",
    });

    return (
        <div className={bodyClass}>
          {bodyTitle && (
            <header>
              <h2 className="cta-block-title heading--2">
                {linkUrl ? (
                  <Link to={linkUrl}>{bodyTitle}</Link>
                ) : (
                    bodyTitle
                  )}
              </h2>
            </header>
          )}

          {this.convertBodyText()}

          {this.props.children &&
            this.props.children
          }

          {(linkUrl && linkText) && (
            <div className="cta-block-button">
              <LinkButton
                to={linkUrl}
                className="primary-button heading--4 text--light"
              >
                {linkText}
              </LinkButton>
            </div>
          )}
        </div>
      );
  }

  private fallbackImage = (): ISrcSet => {
    const customSrcSet: ISrcSet = {
      default: "https://resources.travellocal.com/homepage/inspiration_large.jpg",
      srcs: [
        {
          src: "https://resources.travellocal.com/homepage/inspiration_small.jpg",
          width: 512,
        },
        {
          src: "https://resources.travellocal.com/homepage/inspiration_large.jpg",
          width: 1920,
        },
      ],
    };
    return customSrcSet;
  }

  public render() {
    const { backgroundImage, alt } = this.props;
    return (
      <section className="cta-block">
        <div className="cta-block-container">
          <div className="cta-block-img-wrapper">
            <LazyLoadImage className="cta-block-img" src={ backgroundImage || this.fallbackImage() } alt={alt}/>
          </div>
          {this.displayContent()}
        </div>
      </section>
    );
  }
}
